import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {acceptAgreement} from '../actions/dashboard';
import {logout} from "../../authentication/actions/authentication";
import {
    getSettingsIsAgreed
} from "../../shared/settings/selectors/selector";
import {receiveMessage} from "../../shared/messenger/actions/messenger";
import {config} from "../../main/config";

const AgreementComponent: React.FC = () => {
    const [agreementText, setAgreementText] = useState<string>('');
    const isAgreed = useSelector(getSettingsIsAgreed())
    const dispatch = useDispatch();

    useEffect(() => {
        if (config.showAgreement && !isAgreed && !agreementText) {
            fetch('agreement.html', {cache: 'no-cache'})
                .then(response => response.text())
                .then(text => text.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, ''))
                .then(text => setAgreementText(text))
                .catch(error => dispatch(receiveMessage('', new Error('dashboard.agreement.failure'), true)));
            }
        }, [isAgreed, agreementText]);
    if (!config.showAgreement || isAgreed || !agreementText) {
        return (<></>);
    }
    return (
        <div className="agreement-overlay" style={{display: 'block'}}>
            <div className="agreement modal" role="dialog" data-backdrop="static" data-keyboard="false" style={{display: 'block'}}>
                <div className="agreement-text" dangerouslySetInnerHTML={{__html: agreementText}}/>
                <div className="agreement-buttons">
                    <button className="btn btn-secondary btn-disagree" onClick={() => dispatch(logout(null))}>Reject and Exit</button>
                    <button className="btn btn-primary btn-agree" onClick={() => dispatch(acceptAgreement())}>Accept</button>
                </div>
            </div>
        </div>
    );
};

export default AgreementComponent;
